import {makeAutoObservable} from 'mobx';

export interface EnvironmentConfig {
    settingsUrl: string;
    hlUrl: string;
    skillsApiUrl: string;
    catalogApiUrl: string;
    accreditationApiUrl: string;
    messagesApiUrl: string;
    ssoApiUrl: string;
    domSecManagementApiUrl: string;
    accessManagementApiUrl: string;
    academyDepartmentsUrl: string;
    planningIntegrationApiUrl: string;
    reportApiUrl: string;
    importApiUrl: string;
    notificationsApiUrl: string;
    apiUrl: string;
    authority: string;
}

class LeerplatformSettingsStore {
    private config: EnvironmentConfig = {
        settingsUrl: '',
        hlUrl: '',
        skillsApiUrl: '',
        catalogApiUrl: '',
        accreditationApiUrl: '',
        messagesApiUrl: '',
        ssoApiUrl: '',
        domSecManagementApiUrl: '',
        accessManagementApiUrl: '',
        academyDepartmentsUrl: '',
        planningIntegrationApiUrl: '',
        reportApiUrl: '',
        importApiUrl: '',
        notificationsApiUrl: '',
        apiUrl: '',
        authority: '',
    };

    constructor() {
        makeAutoObservable(this);
    }

    // Getters
    get getSettingsUrl(): string {
        return this.config.settingsUrl;
    }
    get getHlUrl(): string {
        return this.config.hlUrl;
    }
    get getSkillsApiUrl(): string {
        return this.config.skillsApiUrl;
    }
    get getCatalogApiUrl(): string {
        return this.config.catalogApiUrl;
    }
    get getAccreditationApiUrl(): string {
        return this.config.accreditationApiUrl;
    }
    get getMessagesApiUrl(): string {
        return this.config.messagesApiUrl;
    }
    get getSsoApiUrl(): string {
        return this.config.ssoApiUrl;
    }
    get getDomSecManagementApiUrl(): string {
        return this.config.domSecManagementApiUrl;
    }
    get getAccessManagementApiUrl(): string {
        return this.config.accessManagementApiUrl;
    }
    get getAcademyDepartmentsUrl(): string {
        return this.config.academyDepartmentsUrl;
    }
    get getPlanningIntegrationApiUrl(): string {
        return this.config.planningIntegrationApiUrl;
    }
    get getReportApiUrl(): string {
        return this.config.reportApiUrl;
    }
    get getImportApiUrl(): string {
        return this.config.importApiUrl;
    }
    get getNotificationsApiUrl(): string {
        return this.config.notificationsApiUrl;
    }
    get getApiUrl(): string {
        return this.config.apiUrl;
    }
    get getAuthority(): string {
        return this.config.authority;
    }

    // Single setter for the entire config
    setConfig(newConfig: Partial<EnvironmentConfig>) {
        this.config = {...this.config, ...newConfig};
    }

    async loadEnvironmentConfig(): Promise<EnvironmentConfig> {
        if (!this.config.apiUrl) {
            const response = await fetch('/environment.json');
            const envJson = await response.json();
            this.setConfig(envJson);
        }
        return this.config;
    }
}

export const leerplatformSettingsStore = new LeerplatformSettingsStore();
